import { ScaleAssignment, scaleAssignmentSchema } from "@fatbees/schemas";

export async function putAssignment(
  assignment: ScaleAssignment,
): Promise<void> {
  const response = await fetch(
    `/api/hive-assignments/${encodeURIComponent(assignment.id)}`,
    {
      method: "PUT",
      body: JSON.stringify({
        hiveId: assignment.hiveId,
        scaleId: assignment.scaleId,
        assignedAt: assignment.assignedAt,
        unassignedAt: assignment.unassignedAt,
      }),
      headers: { "content-type": "application/json" },
      credentials: "same-origin",
    },
  );
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  scaleAssignmentSchema.parse(await response.json());
}

export async function deleteAssignment(
  assignment: ScaleAssignment,
): Promise<void> {
  const response = await fetch(
    `/api/hive-assignments/${encodeURIComponent(assignment.id)}`,
    { method: "DELETE", credentials: "same-origin" },
  );
  if (!response.ok && response.status !== 204) {
    throw new Error(response.statusText);
  }
}
